const TITLE = `Find out how safe this car is...`;
const TEXT = `howsafeisyourcar.com.au is an easy way to view and compare safety rating and details between cars, take a look at what I’ve found and try it yourself.`;

export { TITLE, TEXT };
